export const locales = [
	"en",
	"de",
	"fr",
	"es",
	"nl",
	"it",
	"pl",
	"pt",
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeNames: Record<Locale, string> = {
	en: "English",
	de: "Deutsch",
	fr: "Français",
	es: "Español",
	nl: "Nederlands",
	it: "Italiano",
	pl: "Polski",
	pt: "Português",
};

/** HTML lang attributes per locale */
export const localeHtmlLang: Record<Locale, string> = {
	en: "en",
	de: "de",
	fr: "fr",
	es: "es",
	nl: "nl",
	it: "it",
	pl: "pl",
	pt: "pt",
};

/** Check if a string is a valid locale */
export function isLocale(value: string): value is Locale {
	return locales.includes(value as Locale);
}

/**
 * Locales for which legal pages are available in the native language.
 * Legal content (ToS, withdrawal, privacy) is DE/EN only. All other locales
 * serve the EN text, so advertising hreflang for them is misleading.
 * Restricting to ["de", "en"] avoids Unfair Terms Directive / distance-selling
 * clarity issues for EU consumers in fr/es/nl/it/pl/pt.
 * Full translations can be added later to expand this list.
 */
export const legalLocales = ["de", "en"] as const satisfies readonly Locale[];
export type LegalLocale = (typeof legalLocales)[number];
